var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreActions = function SvgMoreActions(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 8.66659C7.64498 8.66659 8.16732 8.14425 8.16732 7.49992C8.16732 6.85559 7.64498 6.33325 7.00065 6.33325C6.35632 6.33325 5.83398 6.85559 5.83398 7.49992C5.83398 8.14425 6.35632 8.66659 7.00065 8.66659Z",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 4.00008C7.64498 4.00008 8.16732 3.47775 8.16732 2.83341C8.16732 2.18908 7.64498 1.66675 7.00065 1.66675C6.35632 1.66675 5.83398 2.18908 5.83398 2.83341C5.83398 3.47775 6.35632 4.00008 7.00065 4.00008Z",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00065 13.3333C7.64498 13.3333 8.16732 12.811 8.16732 12.1667C8.16732 11.5223 7.64498 11 7.00065 11C6.35632 11 5.83398 11.5223 5.83398 12.1667C5.83398 12.811 6.35632 13.3333 7.00065 13.3333Z",
    stroke: "#7B8794",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreActions);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/more-actions.f71889f6c372c9c510624b761d0af734.svg";